'use strict';

require('../../style/index.css');

require('./index.css');


//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/button/style/css.js
// module id = 73
// module chunks = 162898551421021 169471311735450 174759553322802